<template>
    <li
        class="navigation_item vf-tooltip-toggle primary-link"
        :class="name"
        :id="name"
    >
        <a
            class="head head-link js-head-link vf-expanding-hover-light"
            :class="{ 'vf-active': isActive }"
            :href="href"
            :target="openInNewTab ? '_blank' : '_self'"
        >
            {{ content }}
            <pill-badge
                v-if="isNew"
                class="navigation-item__new-badge vf-badge__small vf-badge__error"
                :palette="palette"
            >
                {{ $i18n(`analytics.nav.new`) }}
            </pill-badge>
            <pill-badge
                v-if="isBeta"
                class="navigation-item__beta-badge vf-badge__small vf-badge__error"
                :palette="palette"
            >
                {{ $i18n(`analytics.nav.beta`) }}
            </pill-badge>
        </a>
    </li>
</template>

<script>
import { PALETTES } from 'design-assets/constants/palettes.js';
import pillBadge from 'design-assets/components/badge/pill-badge.vue';
import VueTypes from 'commons/util/vue-types.js';

export default {
    props: {
        user: VueTypes.object,
        name: VueTypes.name,
        link: VueTypes.link,
        isActive: VueTypes.bool.def(false),
        baseAdminLink: VueTypes.string.isRequired,
        baseConsoleLink: VueTypes.string,
        basePortalLink: VueTypes.string,
        isNew: VueTypes.bool.def(false),
        isBeta: VueTypes.bool.def(false),
        openInNewTab: VueTypes.bool.def(false),
    },

    beforeCreate() {
        this.palette = PALETTES.DANGER;
    },

    data() {
        return {
            isDropdownOpen: false,
        };
    },

    computed: {
        menuId() {
            return `uh-${this.name}-menu`;
        },
        content() {
            return this.$i18n(`analytics.nav.${this.name}`);
        },
        href() {
            return typeof this.link === 'function'
                ? this.link(
                    {
                        baseAdminLink: this.baseAdminLink,
                        baseConsoleLink: this.baseConsoleLink,
                        basePortalLink: this.basePortalLink,
                    },
                    this.user,
                )
                : null;
        },
        ulProperties() {
            return {
                class: 'primary-navigation-menu',
                id: this.menuId,
            };
        },
        activeClass() {
            return this.isDropdownOpen ? 'vf-active' : '';
        },
    },

    methods: {
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        hide() {
            this.isDropdownOpen = false;
        },
        onItemClick(item) {
            this.$emit('list-item-clicked', item);
        },
        toggleOnEnter(isEntered) {
            // Ticket DXP-1801: Added a "setTimeout".
            // Context: When the user clicks on Dropdown, the "mouseout" event is called before "click". It only happens in Safari.
            //     Basically, "mouseout" event is triggered, the dropdown disappears and the "click" event is not triggered anymore.
            //     With "setTimeout", we wait some milliseconds to close the dropdown and there is enough time to trigger the "click" event.
            setTimeout(() => {
                this.isDropdownOpen = isEntered;
            }, 100);
        },
        getLinkText(key) {
            return this.$i18n(`analytics.nav.${key}`);
        },
    },

    components: {
        pillBadge,
    },
};
</script>
